require('./polyfills')

const { Syncer } = require('#utils/syncer')


function decodeHTMLEntity(x) {
  const unescapes = {
    '&amp;': '&',
    '&quot;': '"',
    '&#x27;': '\'',
    '&gt;': '>',
    '&lt;': '<',
  }
  const re = new RegExp(`(${Object.keys(unescapes).join('|')})`, 'g')
  return String(x).replace(re, (char) => unescapes[char])
}

function loadConfig($document) {
  return JSON.parse(decodeHTMLEntity($document.getElementById('config').textContent))
}

/* eslint-disable no-undef */
function onload(callback) {
  /* node:coverage disable */
  if (typeof window !== 'undefined') {
    window.document.addEventListener('DOMContentLoaded', () => callback(window))
  }
  /* node:coverage enable */
}
/* eslint-enable no-undef */

function App($window, $location = $window.location, $document = $window.document) {
  $window.addEventListener('error', event => {
    logError(event.error)
  })
  $window.addEventListener('unhandledrejection', event => {
    logError(event.reason)
  })

  const config = loadConfig($document)
  // document.documentElement is the root HTML element
  const { sync } = new Syncer($document.documentElement)
  let state = null
  return Object.freeze({
    $window,
    $location,
    config,
    get state() { return state },
    set state(x) {
      state = x
      sync(state)
    },
    sync
  })

  function logError(err) {
    const stack = (typeof err.stack !== 'string')
      ? `${err}`
      : err.stack.startsWith(err.name)
      ? err.stack
      : `${err.name}: ${err.message}\n${err.stack}`
    $window.navigator.sendBeacon(`${config.apiRoot}/telemetry/error`, stack)
  }
}
App.init = (PageConstructor) => {
  const init = (...args) => {
    const app = new App(...args)
    app.state = PageConstructor(app)
    // Setting app on window is just handy for debugging, not actually necessary.
    // I should probably not do this in production.
    app.$window.app = app
    // Likewise for returning app. Just handy for tests to get a reference.
    return app
  }
  onload(init)
  return init
}

exports.App = App
